import { Get, Remove, Set } from "../../../../../Request";

export const FormSubmit = async data => {
  await Set({
    url: "/joiningrequest/store",
    data: data,
  });
};

export const GetData = async (pageNumber, type, limit = 15, filter) => {
  return await Get({
    url: "/cooperation/admin_list",
    data: {
      limit: limit,
      type: type,
      ...filter,
    },
    page: pageNumber,
  }).then(data => {
    return data;
  });
};

export const DeleteData = async data => {
  await Remove({
    url: "/Cooperation/destroy",
    data: data,
  });
};
